<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} System</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'active' && field.name !== 'application') || (field.name === 'name' && editMode)"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control responsive-input" :disabled="(field.name === 'name') && editMode">
              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>
              <input class="checkbox" v-else-if="field.name === 'active'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>

            <div v-if="error !== ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create System' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {System} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'SystemEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        name : this.$route.params.name,
        value : this.$route.params.value,
        application: this.$route.params.application,
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "name", label: "Name" },
        { name: "value", label: "Value" },
        { name: "application", label: "Application" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.name) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new System(
          this.editedConfig.name,
          this.editedConfig.value,
          this.editedConfig.application
      );
      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateSystem(dataToSave).then(() => {
          alert('Update complete');
          // Redirect to the page
          this.$router.push({ name: 'System' });
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertSystem(dataToSave).then(() => {
          alert('Insert complete');
          // Redirect to the page
          this.$router.push({ name: 'System' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
